import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Gavel, MapPin, Calendar, Clock, TrendingUp, Filter } from 'lucide-react';
export function AuctionsPage() {
  const [filterStatus, setFilterStatus] = useState('all');
  const auctions = [{
    id: '1',
    title: 'Prime Commercial Land - Hinjewadi Phase 3',
    location: 'Hinjewadi, Pune',
    area: '5,000 Sq. Ft',
    basePrice: '₹1.5 Cr',
    currentBid: '₹1.8 Cr',
    bids: 12,
    status: 'active',
    endDate: '2024-10-25',
    timeLeft: '2 days'
  }, {
    id: '2',
    title: 'Residential Plot - Wagholi',
    location: 'Wagholi, Pune',
    area: '3,200 Sq. Ft',
    basePrice: '₹85 Lakhs',
    currentBid: '₹92 Lakhs',
    bids: 8,
    status: 'active',
    endDate: '2024-10-28',
    timeLeft: '5 days'
  }, {
    id: '3',
    title: 'Industrial Land Parcel - Chakan',
    location: 'Chakan, Pune',
    area: '10,000 Sq. Ft',
    basePrice: '₹3.2 Cr',
    currentBid: '₹3.5 Cr',
    bids: 15,
    status: 'active',
    endDate: '2024-11-02',
    timeLeft: '10 days'
  }, {
    id: '4',
    title: 'Commercial Plot - Baner',
    location: 'Baner, Pune',
    area: '2,800 Sq. Ft',
    basePrice: '₹1.2 Cr',
    currentBid: '₹1.4 Cr',
    bids: 18,
    status: 'closed',
    endDate: '2024-10-15',
    timeLeft: 'Closed'
  }];
  const filteredAuctions = auctions.filter(auction => {
    if (filterStatus === 'all') return true;
    return auction.status === filterStatus;
  });
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-2155">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6 md:px-12" data-id="element-2156">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-2157">
          <Link to="/" className="flex items-center gap-2" data-id="element-2158">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-2159"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-2160">
              Citiplots.com
            </span>
          </Link>
          <nav className="hidden md:flex gap-8 text-sm font-medium text-gray-600" data-id="element-2161">
            <Link to="/" data-id="element-2162">Buy Plots</Link>
            <Link to="/auctions" className="text-[#1f2933]" data-id="element-2163">
              Auctions
            </Link>
            <Link to="/legal-guides" data-id="element-2164">Legal Guides</Link>
            <Link to="/advocacy" data-id="element-2165">Advocacy</Link>
          </nav>
        </div>
      </header>

      <main className="flex-1" data-id="element-2166">
        {/* Hero Section */}
        <section className="bg-white border-b border-gray-300 py-16 px-6 text-center" data-id="element-2167">
          <div className="max-w-4xl mx-auto" data-id="element-2168">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-2169">
              <Gavel className="w-8 h-8" data-id="element-2170" />
              <h1 className="text-4xl md:text-5xl font-bold" data-id="element-2171">
                Government Land Auctions
              </h1>
            </div>
            <p className="text-lg text-gray-500 mb-8 font-mono" data-id="element-2172">
              Transparent, verified land parcels from government authorities
            </p>

            <div className="flex items-center justify-center gap-4 text-sm" data-id="element-2173">
              <div className="px-4 py-2 bg-green-100 border border-green-200" data-id="element-2174">
                <span className="font-bold text-green-800" data-id="element-2175">
                  12 Active Auctions
                </span>
              </div>
              <div className="px-4 py-2 bg-blue-100 border border-blue-200" data-id="element-2176">
                <span className="font-bold text-blue-800" data-id="element-2177">
                  ₹45 Cr Total Value
                </span>
              </div>
              <div className="px-4 py-2 bg-purple-100 border border-purple-200" data-id="element-2178">
                <span className="font-bold text-purple-800" data-id="element-2179">
                  156 Registered Bidders
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Filters */}
        <section className="max-w-7xl mx-auto px-6 py-8" data-id="element-2180">
          <div className="flex items-center gap-4 mb-8" data-id="element-2181">
            <Filter className="w-5 h-5 text-gray-400" data-id="element-2182" />
            <div className="flex gap-2" data-id="element-2183">
              <button onClick={() => setFilterStatus('all')} className={`px-4 py-2 text-sm font-bold border ${filterStatus === 'all' ? 'bg-[#1f2933] text-white border-[#1f2933]' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-2184">
                All Auctions
              </button>
              <button onClick={() => setFilterStatus('active')} className={`px-4 py-2 text-sm font-bold border ${filterStatus === 'active' ? 'bg-[#1f2933] text-white border-[#1f2933]' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-2185">
                Active
              </button>
              <button onClick={() => setFilterStatus('upcoming')} className={`px-4 py-2 text-sm font-bold border ${filterStatus === 'upcoming' ? 'bg-[#1f2933] text-white border-[#1f2933]' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-2186">
                Upcoming
              </button>
              <button onClick={() => setFilterStatus('closed')} className={`px-4 py-2 text-sm font-bold border ${filterStatus === 'closed' ? 'bg-[#1f2933] text-white border-[#1f2933]' : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'}`} data-id="element-2187">
                Closed
              </button>
            </div>
          </div>

          {/* Auction Listings */}
          <div className="grid grid-cols-1 gap-6" data-id="element-2188">
            {filteredAuctions.map(auction => <Link key={auction.id} to={`/authority/auctions/${auction.id}`} className="bg-white border border-gray-300 p-6 hover:shadow-lg transition-shadow" data-id="element-2189">
                <div className="flex items-start justify-between mb-4" data-id="element-2190">
                  <div className="flex-1" data-id="element-2191">
                    <div className="flex items-center gap-3 mb-2" data-id="element-2192">
                      <span className={`px-3 py-1 text-xs font-bold rounded border ${auction.status === 'active' ? 'bg-green-100 text-green-800 border-green-200' : 'bg-gray-100 text-gray-600 border-gray-200'}`} data-id="element-2193">
                        {auction.status === 'active' ? 'LIVE AUCTION' : 'CLOSED'}
                      </span>
                      <span className="px-3 py-1 bg-orange-100 text-orange-800 border border-orange-200 text-xs font-bold" data-id="element-2194">
                        GOVT VERIFIED
                      </span>
                    </div>
                    <h3 className="text-xl font-bold mb-2" data-id="element-2195">{auction.title}</h3>
                    <div className="flex items-center gap-4 text-sm text-gray-600" data-id="element-2196">
                      <span className="flex items-center gap-1" data-id="element-2197">
                        <MapPin className="w-4 h-4" data-id="element-2198" />
                        {auction.location}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-2199">
                        <Calendar className="w-4 h-4" data-id="element-2200" />
                        {auction.area}
                      </span>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-2201">
                    <div className="text-sm text-gray-500 mb-1" data-id="element-2202">
                      Current Bid
                    </div>
                    <div className="text-2xl font-bold text-green-600" data-id="element-2203">
                      {auction.currentBid}
                    </div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-2204">
                      {auction.bids} bids
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-2205">
                  <div className="flex items-center gap-6 text-sm" data-id="element-2206">
                    <div data-id="element-2207">
                      <span className="text-gray-500" data-id="element-2208">Base Price: </span>
                      <span className="font-bold" data-id="element-2209">{auction.basePrice}</span>
                    </div>
                    <div data-id="element-2210">
                      <span className="text-gray-500" data-id="element-2211">Ends: </span>
                      <span className="font-bold" data-id="element-2212">{auction.endDate}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-sm" data-id="element-2213">
                    <Clock className="w-4 h-4 text-gray-400" data-id="element-2214" />
                    <span className={`font-bold ${auction.status === 'active' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-2215">
                      {auction.timeLeft}
                    </span>
                  </div>
                </div>
              </Link>)}
          </div>
        </section>

        {/* How It Works */}
        <section className="bg-white border-t border-gray-300 py-16 px-6" data-id="element-2216">
          <div className="max-w-4xl mx-auto" data-id="element-2217">
            <h2 className="text-3xl font-bold text-center mb-12" data-id="element-2218">
              How Government Auctions Work
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2219">
              {[{
              step: '1',
              title: 'Register & Verify',
              desc: 'Complete KYC and pay EMD to participate'
            }, {
              step: '2',
              title: 'Place Bids',
              desc: 'Submit competitive bids during auction period'
            }, {
              step: '3',
              title: 'Win & Complete',
              desc: 'Highest bidder wins and completes documentation'
            }].map((item, i) => <div key={i} className="text-center" data-id="element-2220">
                  <div className="w-12 h-12 bg-[#1f2933] text-white font-bold text-xl flex items-center justify-center mx-auto mb-4" data-id="element-2221">
                    {item.step}
                  </div>
                  <h3 className="font-bold mb-2" data-id="element-2222">{item.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-2223">{item.desc}</p>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-2224" />
    </div>;
}